<template>
  <div class="headerWrapper">
    <div class="header">
      <h1 class="title">{{ title }}</h1>
      <p class="sub-text">
        {{ subtext }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: {
    title: String,
    subtext: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  width: 50%;
  height: 40%;
  margin: auto;
  margin-top: 5%;

  @media (max-width: 425px) {
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 80%;
  }

  @media (max-width: 1024px) {
    width: 90%;
  }
}

.title {
  font-size: 40px;

  @media (max-width: 425px) {
    font-size: 48px;
  }

  @media (max-width: 768px) {
    padding-top: 35px;
    font-size: 40px;
  }
}

.sub-text {
  font-size: 16px;
  margin-top: -15px;

  @media (max-width: 425px) {
    width: 80%;
    margin-left: auto;
    margin-right: auto;

    font-size: 17px;
  }

  @media (max-width: 768px) {
    width: 85%;
    margin-left: auto;
    margin-right: auto;

    font-size: 17px;
  }

  @media (max-width: 1024px) {
    width: 85%;
    margin-left: auto;
    margin-right: auto;

    font-size: 16px;
  }
}
</style>
